import React from 'react';
import styled from 'styled-components';

import InclusionWrap from '../InclusionWrap/InclusionWrap';
import EarlyCheckinBlock from '../EarlyCheckinBlock/EarlyCheckinBlock';

import ThingsYouShouldKnow from '../../DetailsPage/ThingsYouShouldKnow/ThingsYouShouldKnow';

const HotelInclusion: React.FC<{
  freeCancellationDate: string;
  addOnList: Array<object>;
  earlycheckin: boolean;
  roomType: string;
  extraMessages: Array<object>;
  hotelsPolicy: Array<string>;
  cancellationPolicy: Array<string>;
  thingsYoushouldKnow: Array<string>;
}> = ({
  freeCancellationDate,
  addOnList = [],
  earlycheckin,
  roomType,
  extraMessages,
  hotelsPolicy,
  cancellationPolicy,
  thingsYoushouldKnow,
}) => (
  <>
    <HotelInclusionWrapDiv>
      <InclusionWrap
        freeCancellationDate={freeCancellationDate}
        extraMessages={extraMessages}
        hotelsPolicy={hotelsPolicy}
        cancellationPolicy={cancellationPolicy}
      ></InclusionWrap>
      {!!addOnList.length && (
        <EarlyCheckinBlock addOnList={addOnList} earlycheckin={earlycheckin} roomType={roomType} />
      )}
    </HotelInclusionWrapDiv>

    {!!thingsYoushouldKnow.length && <ThingsYouShouldKnow list={thingsYoushouldKnow} />}
  </>
);

export default HotelInclusion;

const HotelInclusionWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
    padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l20};
  `
);
